import * as Integration from '@/services/rest-api/lib/setting/integration'

export default [
  {
    name: 'Accurate',
    code: 'ACCURATE',
    description: 'ACCURATE Accounting Software adalah program akuntansi yang user friendly, job costing software yang memudahkan anda dalam menyusun laporan keuangan, laporan laba rugi, dan masih banyak lagi.',
    icon_url: require('@/assets/images/setting/integration/accurate.png'),
    group: 'Akuntansi',
    connect: Integration.accurateConnect,
    disconnect: Integration.accurateDisconnect,
    property: 'authorization_code'
  },
  {
    name: 'Jurnal',
    code: 'JURNAL',
    description: 'Mekari Jurnal adalah software akuntansi online yang terintegrasi & kembangkan bisnis tanpa batas.',
    icon_url: require('@/assets/images/setting/integration/jurnal.png'),
    group: 'Akuntansi',
  }
]